/** A nav link: label-key decoupled from its scroll target (e.g. Program→value-promise). labelKey resolves in PROGRAM_SECTIONS_I18N_NAMESPACE. */
export interface NavItem {
  id: string
  labelKey: string
  targetId: string
}

/** Program→value-promise, Instructors→instructors, Curriculum→curriculum. */
export const PROGRAM_NAV_ITEMS: readonly NavItem[] = [
  { id: 'program', labelKey: 'nav.program', targetId: 'value-promise' },
  { id: 'instructors', labelKey: 'nav.instructors', targetId: 'instructors' },
  { id: 'curriculum', labelKey: 'nav.curriculum', targetId: 'curriculum' },
]
